"use strict";
/** 
* Предоставляет работу со списками объектов  в проводнике. 
* Например, получить список отфильтрованных объектов – задач, заданий и уведомлений в проводнике, выделить объекты в списке закладок, 
* снять выделение с элементов табличной части справочника.
*
* @class WebAccess.components.wrappers.objectList.FolderList
* @since 5.2.0.2000
*/

(function (global) {

  var FolderList = global.CMP.wrappers.objectList.ObjectList.extend({
    state: null,
    init: function () {
      var me = this;
      me._super.apply(me, arguments);
      me.state = {
        likeFilterValue: '',
        likeFilterRequisites: null,
        predefinedFilter: null,
        sort: null,
        sortIsAsc: true,
        isShowFolders: null
      }
    },

    setPredefinedFilter: function (name) {
      this.state.predefinedFilter = name;
      return this;
    },
    getPredefinedFilter: function () {
      return this.state.predefinedFilter;
    },
    isPredefinedFilterEmpty: function () {
      return !this.state.predefinedFilter;
    },

    setSort: function (name, sortIsAsc) {
      if (_.isObject(name)) {
        this.state.sort = name.name;
        this.state.sortIsAsc = name.sortIsAsc;
      } else {
        this.state.sort = name;
        this.state.sortIsAsc = sortIsAsc;
      }
      return this;
    },
    getSort: function () {
      return {
        name: this.state.sort,
        sortIsAsc: this.state.sortIsAsc
      }
    },

    setLikeFilter: function (likeValue, likeRequisites) {
      this.state.likeFilterValue = likeValue;
      this.state.likeFilterRequisites = likeRequisites;
      return this;
    },
    getLikeFilter: function () {
      return this.state.likeFilterValue;
    },
    getlikeFilterRequisites: function () {
      return this.state.likeFilterRequisites;
    },

    /*
     * Перезагружает содержимое текущей папки.
     */
    reload: function () {
      var me = this;
      var d = $.Deferred();

      var jMainContainer = $('#main_container');
      var jObjectContents = $('.object_contents');

      var currentScrollTop;
      if ($.scrollActive) {
        currentScrollTop = jMainContainer.offset().top - jObjectContents.offset().top;
      } else {
        currentScrollTop = jMainContainer.scrollTop();
      }
      var jFolderItems = jObjectContents.children('.folder_item');

      // Вычисляем какая страница сейчас показана на экране у пользователя. Округляем в большую сторону, чтобы если даже часть след. страницы показана, она загрузилась.
      var pageHeight = g_MaxRowsPerPage * jFolderItems.first().outerHeight();
      var shownPage = (pageHeight === 0) ? 0 : Math.ceil(((currentScrollTop + jMainContainer.height()) / pageHeight));

      var currentFolderId = WA.CR.getID();

      me._loadAndInsertNewPage({
        folderId: currentFolderId,
        pageNumber: 1,
        pageCountToLoad: shownPage,
        needUseFilters: true,
        needUseSort: true,
        afterLoadCallback: function () {
          // Смещаем скрол на предыдущее место.
          jMainContainer.scrollTop(currentScrollTop);
          d.resolve();
        }
      });

      return d.promise();
    },

    /*
     * Загружает контент произвольной папки.
     */
    loadFolderContent: function (folderId) {
      var d = $.Deferred();
      this._loadAndInsertNewPage({
        folderId: folderId,
        pageNumber: 1,
        pageCountToLoad: 1,
        needUseFilters: false,
        needUseSort: false,
        afterLoadCallback: function () {
          // Смещаем скрол в начало страницы.
          $('#main_container').scrollTop(0);
          d.resolve();
        }
      });

      return d.promise();
    },

    // Загружает и вставляет в HTML-контейнер нужную страницу объектов.
    _loadAndInsertNewPage: function (params) {
      var me = this;
      var jObjectContents = $('.object_contents');

      var nextPage;
      var itemsToLoad;
      if (params.pageCountToLoad && params.pageCountToLoad > 0) {
        itemsToLoad = params.pageCountToLoad * g_MaxRowsPerPage;
        // Если грузим больше объектов чем на 1 страницы, то учитываем это в след. странице.
        nextPage = params.pageCountToLoad + 1;
      } else {
        itemsToLoad = g_MaxRowsPerPage;
        nextPage = params.pageNumber + 1;
      }

      WA.CR.ID = params.folderId;
      jObjectContents.data('nextPage', nextPage);

      me._loadPage(params.folderId, params.pageNumber, itemsToLoad, params.needUseFilters, params.needUseSort).done(function (html) {
        if (!CheckForLoginPage(html)) {

          jObjectContents.html(html);

          if ($.isFunction(params.afterLoadCallback)) {
            params.afterLoadCallback.call(me);
          }

          //HACK: Для IE11 не работают действие по наименованию записанные в атрибуте onclick. Такой хак заставляет их работать.
          if (WA.ENV.browser.name === 'IE' && WA.ENV.browser.major === '11') {
            $.each(jObjectContents.find('div[onclick]'), function () {
              var onclick = $(this).attr('onclick');
              $(this).attr('onclick', onclick + ';');
            });
          }

          jObjectContents.children().first().addClass('hover');
          if (jObjectContents.children('.folder_item').length == 0) {
            var emptyMessage = L('EMPTY');
            if (params.needUseFilters && me.getPredefinedFilter() || me.getLikeFilter()) {
              emptyMessage = L('EMPTY_WITH_FILTER');
            }
            jObjectContents.append('<div class="Empty object-list_empty-wide"><div class="container-watermark"><div class="container-watermark__img container-watermark__img_empty-filter"></div><div class="container-watermark__label">' + emptyMessage + '</div></div></div>');
          }
          EntityListInit(jObjectContents, true);
          if (params.needUseFilters) {
            InitObjectContentsAutoLoad(me.state.likeFilterValue, me.state.likeFilterRequisites);
          } else {
            InitObjectContentsAutoLoad();
          }

          me.updateState();
        }
      });
    },

    // Загружает HTML-кода pageNumber страницы с элементами из папки с ИД = folderId.
    _loadPage: function (folderId, pageNumber, opt_itemsToLoad, opt_needUseFilters, opt_needUseSort) {
      var me = this;
      var def = $.Deferred();

      var jObjectContents = $('.object_contents');
      var uid = '';
      if (jObjectContents.data('uid')) {
        uid = jObjectContents.data('uid');
      }

      var newQueryParams = {
        c: jObjectContents.data('component'),
        id: folderId,
        page: pageNumber,
        itemsToLoad: opt_itemsToLoad || -1,
        ctrl: encodeURIComponent(jObjectContents.attr('id')),
        uid: uid
      };

      if (opt_needUseFilters !== false) {
        $.extend(newQueryParams, {
          filterValue: me.state.likeFilterValue,
          filterReq: me.state.likeFilterRequisites,
          predefinedFilter: me.state.predefinedFilter
        });
      }

      if (opt_needUseSort !== false) {
        $.extend(newQueryParams, {
          sort: (me.state.sortIsAsc ? '' : '-') + me.state.sort
        });
      }

      var currentQueryParams = new WA.URL(location.search.substr(1));
      currentQueryParams.removeParam('sort');
      currentQueryParams.removeParam('id');
      currentQueryParams.removeParam('fpath');

      ShowTopSpinner();
      $.ajax({
        type: "GET",
        dataType: "html",
        url: "DynControl.ashx?" + currentQueryParams.asString() + '&' + $.param(newQueryParams),
        cache: false,
        success: function (res) {
          HideTopSpinner('', 0);
          def.resolve(res);
        },
        error: function (err) {
          HideTopSpinner('', 0);
          def.reject(err);
        }
      });

      return def.promise();
    },

    /**
     * Обновляет внутренее состояние списка и перестраивает объект КОМ.
     * @param {object} state Состояние объекта. 
     */
    updateState: function (state) {
      var me = this;
      if (state) $.extend(me.state, state);

      //Обновим объект клиентской ОМ
      me.fire("itemsChange");
      me.fire("itemUnSelect", {});

      //Сбросим переключатель выделения всех объектов.
      me._isAllSelected = false;
    },

    /**
     * Устанавливает флаг отображения папок в состоянии объекта.
     * @param {} value Значение флага. 
     */
    setIsShowFolders: function(value) {
      this.state.isShowFolders = value;
    },

    /**
     * Необходимо ли показывать папки.
     * 
     * @returns {boolean} 
     */
    isShowFolders: function() {
      return !!this.state.isShowFolders;
    }
  });

  global.CMP.wrappers.objectList.FolderList = FolderList;

})(window.WebAccess);